import { jsx } from "react/jsx-runtime";
import assert from "assert";
import { useId } from "react";
import { flattenChildren } from "../../utils/flattenChildren.mjs";
import { RadioItem } from "./RadioItem.mjs";
import { Stack } from "../Stack/Stack.mjs";
import { FieldGroup } from "../private/FieldGroup/FieldGroup.mjs";
import { RadioGroupContext, RadioItemContext } from "./RadioGroupContext.mjs";
const stackSpaceForSize = {
  small: "xsmall",
  standard: "small"
};
const RadioGroup = ({
  children,
  value,
  name,
  onChange,
  disabled,
  tone,
  size,
  ...props
}) => {
  const items = flattenChildren(children);
  assert(
    items.every(
      (item) => typeof item === "object" && "type" in item && item.type === RadioItem
    ),
    "All child nodes within a RadioGroup must be a RadioItem: https://seek-oss.github.io/braid-design-system/components/RadioGroup"
  );
  const fallbackName = useId();
  return /* @__PURE__ */ jsx(
    FieldGroup,
    {
      ...props,
      componentName: "RadioGroup",
      disabled,
      tone,
      role: "radiogroup",
      messageSpace: "small",
      children: (fieldGroupProps) => /* @__PURE__ */ jsx(
        RadioGroupContext.Provider,
        {
          value: {
            value,
            name: name || fallbackName,
            onChange,
            disabled,
            tone,
            size,
            ...fieldGroupProps
          },
          children: /* @__PURE__ */ jsx(Stack, { space: stackSpaceForSize[size || "standard"], children: items.map((item, i) => /* @__PURE__ */ jsx(RadioItemContext.Provider, { value: i, children: item }, i)) })
        }
      )
    }
  );
};
RadioGroup.displayName = "RadioGroup";
export {
  RadioGroup
};
